import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function Recintos() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('idpropietario', 'Propietario'),
      Table.Field('nombre', 'Nombre'),
      Table.Field('ciudad', 'Ciudad'),
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('recinto', 'nombre', 'idrecinto')
    )
  )
  
  return (
    <div>
      <h2>Recintos</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
